import { cn, LoadingSpinner, Separator, Table } from 'twyne-new.ui'

import { useGrid, useGridBulkActions } from '@Components/Grid/context';

import Pagination from "./Pagination";

export default function TableWrapper({ children, hadResized }) {
  const { store: { loading } } = useGrid()

  return <>
    <ActionsCheckboxes />
    {loading && <LoadingOverlay />}
    <Table className={cn('w-full min-w-full', loading && 'opacity-50', hadResized && 'table-fixed')} containerClassName='pl-2'>
      {children}
    </Table>
    <Pagination />
  </>
}

function LoadingOverlay() {
  return <div className='sticky top-20 z-40 h-0 flex justify-center pointer-events-none'>
    <LoadingSpinner />
  </div>
}

function ActionsCheckboxes() {
  const { rowsSelected, definitions } = useGrid()
  const BulkActions = useGridBulkActions()
  const { entityNamePlural, entityName } = definitions
  const selectedCount = rowsSelected.length
  const showBulkHeader = selectedCount > 0

  if (!BulkActions) {
    return null
  }

  return <div className={cn(
    'w-full flex items-center px-5 gap-2 overflow-hidden transition-all duration-200 ease-in-out',
    showBulkHeader ? 'max-h-14 py-3 opacity-100 translate-y-0 border-b twy-border-base' : 'max-h-0 py-0 opacity-0 -translate-y-1 border-b border-transparent pointer-events-none')
  }>
    <div>
      <span className='twy-text-base-accent mr-1'>{selectedCount}</span>
      <span>{rowsSelected.length === 1 ? entityName : entityNamePlural} selected</span>
    </div>
    <Separator orientation='vertical' className='py-2' />
    <BulkActions />
  </div>
}
